/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAirdropTicketLogs.vue?vue&type=template&id=47e4ef0d&scoped=true"
import script from "./popAirdropTicketLogs.vue?vue&type=script&lang=js"
export * from "./popAirdropTicketLogs.vue?vue&type=script&lang=js"
import style0 from "./popAirdropTicketLogs.vue?vue&type=style&index=0&id=47e4ef0d&prod&lang=scss&scoped=true"
import style1 from "./popAirdropTicketLogs.vue?vue&type=style&index=1&id=47e4ef0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e4ef0d",
  null
  
)

export default component.exports